import { render, staticRenderFns } from "./Card10.vue?vue&type=template&id=5074f32e&scoped=true"
import script from "./Card10.vue?vue&type=script&lang=js"
export * from "./Card10.vue?vue&type=script&lang=js"
import style0 from "./Card10.vue?vue&type=style&index=0&id=5074f32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5074f32e",
  null
  
)

export default component.exports